var map = {
	"./author/author-1.jpg": 9594,
	"./blog-big-1.jpg": 6074,
	"./blog-big-2.jpg": 2325,
	"./blog-big-3.jpg": 4456,
	"./blog-big-4.jpg": 7899,
	"./blog-big-5.jpg": 9854,
	"./comment/comments-1.png": 4255,
	"./comment/comments-rep-1.png": 5245,
	"./comment/comments-rep-2.png": 3622,
	"./quote-icon.png": 5927,
	"./rc/rc-1.jpg": 4634,
	"./rc/rc-2.jpg": 885,
	"./rc/rc-3.jpg": 3016,
	"./sm1.jpg": 5228,
	"./sm2.jpg": 1675,
	"./sm3.jpg": 1518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6385;